import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitTimeBannerComponent } from './wait-time-banner.component';



@NgModule({
  declarations: [WaitTimeBannerComponent],
  imports: [
    CommonModule,
  ],
  exports: [WaitTimeBannerComponent]
})
export class WaitTimeBannerModule { }
